<template>
  <!-- 開啟手機板MENU時的遮罩-->
  <div class="menu-overlay" :class="{ show: open }" @click="closeMenu"></div>
  <!--  手機板MENU-->
  <div v-show="!isFullHeader" class="menu-drawer" :class="{ open: open }">
    <div class="menu-drawer-header">
      <StaticImage src="logo_hitrust.png" class="header-logo" />
      <button class="menu-close-btn" @click="closeMenu">✕</button>
    </div>
    <div class="menu-drawer-body">
      <template :key="item.functionId + '_MOBILE'" v-for="item in MENU">
        <!-- 第一層MENU-->
        <template v-if="item.children">
          <div class="menu-first-level">
            <template v-if="hasRoute(item.functionId)">
              <router-link :to="{ name: item.functionId }" custom v-slot="{ href, navigate }">
                <div style="flex: 1" @click="mobileLink($event, navigate, item)">
                  <a :href="href" :id="item.functionId">
                    {{ item.menuText }}
                  </a>
                </div>
              </router-link>
            </template>
            <template v-else>
              <div style="flex: 1">{{ item.menuText }}</div>
            </template>
            <div style="
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
              " @click="setActiceId(item.functionId)">
              <span class="down-arrow" :class="{ active: checkActive(item.functionId) }"></span>
            </div>
          </div>
          <!-- 第二層MENU-->
          <div class="sub-menu" :class="{ active: checkActive(item.functionId) }">
            <div class="sub-menu-group" :key="item.functionId + '_MOBILE'" v-for="level2Item in item.children">
              <template v-if="level2Item.children">
                <div class="menu-level2">
                  {{ level2Item.menuText }}
                </div>
                <template :key="item.functionId + '_MOBILE'" v-for="level3Item in level2Item.children">
                  <template v-if="hasRoute(level3Item.functionId)">
                    <router-link :to="{ name: level3Item.functionId }" custom v-slot="{ href, navigate }">
                      <div class="menu-level3" @click="mobileLink($event, navigate, level3Item)">
                        <a :href="href" :id="item.functionId">
                          {{ level3Item.menuText }}
                        </a>
                      </div>
                    </router-link>
                  </template>
                  <template v-else>
                    <div class="menu-level3">
                      {{ level3Item.menuText }}
                    </div>
                  </template>
                </template>
              </template>
              <template v-else-if="hasRoute(level2Item.functionId)">
                <router-link :to="{ name: level2Item.functionId }" custom v-slot="{ href, navigate }">
                  <div class="menu-level2" @click="mobileLink($event, navigate, level2Item)">
                    <a :href="href" :id="item.functionId">
                      {{ level2Item.menuText }}
                    </a>
                  </div>
                </router-link>
              </template>
              <template v-else>
                <div class="menu-level2">
                  {{ level2Item.menuText }}
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="hasRoute(item.functionId)">
          <router-link :to="{ name: item.functionId }" custom v-slot="{ href, navigate }">
            <div role="button" class="menu-first-level" @click="mobileLink($event, navigate, item)">
              <a :href="href" :id="item.functionId">
                {{ item.menuText }}
              </a>
            </div>
          </router-link>
        </template>
      </template>
      <!-- 底部功能按鈕區 -->
      <div class="menu-action-block">
        <div class="btn-action-sc" @click="openSc">商家後台登入</div>
        <router-link :to="{ name: 'ContactUs' }" custom v-slot="{ href, navigate }">
          <a :href="href" @click="mobileLink($event, navigate, { functionId: 'ContactUs' })" id="ContactUs_MOBILE"
            class="btn-action-contact">
            聯絡我們
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    const envData = this.env.getData();
    return {
      open: this.modelValue,
      scUrl: envData.SC_RUL,
      activeId: "",
    };
  },
  props: {
    MENU: {
      type: Object,
    },
    modelValue: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  components: {},
  computed: {
    ...mapGetters("device", {
      isFullHeader: "getIsFullHeader",
    }),
  },
  watch: {
    modelValue(newVal, oldVal) {
      this.open = newVal;
    },
  },
  mounted: function () {
    this.initData();
  },
  methods: {
    initData: function () { },
    closeMenu: function () {
      if (this.open == true) {
        this.$emit("update:modelValue", false);
      }
    },
    openSc: function () {
      window.open(this.scUrl, vue.mewBrowserId);
    },
    checkActive: function (functionId) {
      return functionId == this.activeId;
    },
    getChild: function (menuItem) {
      if (menuItem.children) {
        return menuItem.children;
      } else {
        return [];
      }
    },
    setActiceId: function (functionId) {
      if (this.activeId != functionId) {
        this.activeId = functionId;
      } else {
        this.activeId = "";
      }
    },
    mobileLink: function (event, navigate, item) {
      this.closeMenu();
      this.activeId = "";
      // 最後再導頁
      navigate(event);
    },
  },

  setup(props, context) { },
};
</script>

<style scoped>
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  box-sizing: border-box;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  z-index: 1020;
  display: none;
}

.menu-overlay.show {
  display: block;
}

/* Drawer: 由右側滑入 (Right Drawer) */
.menu-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 80vw;
  max-width: 320px;
  min-width: 260px;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  background: #fff;
  z-index: 1050;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.menu-drawer.open {
  transform: translateX(0);
}

/* Header */
.menu-drawer-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.2rem;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.08);
  height: var(--menu-mobile-height);
  flex-shrink: 0;
}

.menu-close-btn {
  font-size: 1.3rem;
  color: rgba(0, 0, 0, 0.5);
  background-color: transparent;
  border: 0;
  padding: 8px;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Body */
.menu-drawer-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 0 20px 0;
  -webkit-overflow-scrolling: touch;
}

.menu-first-level {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.menu-first-level:active {
  background-color: #f8f9fa;
}

.menu-drawer-body a {
  color: inherit;
  text-decoration: none;
}

/* Sub Menu: 展開時使用淺色底卡片包覆，層次更清晰 */
.sub-menu {
  display: none;
  background: #f8f9fb;
  border-radius: 8px;
  padding: 8px 6px;
  box-sizing: border-box;
}

.sub-menu.active {
  display: block;
}

.sub-menu-group {
  padding-left: 8px;
  margin-bottom: 6px;
}

.sub-menu-group:last-child {
  margin-bottom: 0;
}

.sub-menu-group>div:first-child {
  font-weight: 600;
  font-size: 13px;
  color: var(--color-red, #8C1C36);
  padding: 4px 8px;
}

.menu-level2 {
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
}

.menu-level3 {
  padding: 5px 12px 5px 20px;
  font-size: 13.5px;
  color: #555;
}

.header-logo {
  max-height: 80%;
  width: auto;
}

/* 底部功能按鈕區 */
.menu-action-block {
  padding: 16px 18px 8px 18px;
  margin-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-action-sc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  background: #f1f3f5;
  border: 1px solid #e2e4e8;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.btn-action-sc:active {
  background: #e4e7eb;
}

.btn-action-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  background: var(--color-red, #8C1C36);
  text-decoration: none !important;
  box-shadow: 0 2px 6px rgba(140, 28, 54, 0.25);
  transition: opacity 0.15s ease;
}

.btn-action-contact:active {
  opacity: 0.9;
}
</style>
